import React, { ReactNodeArray, useState, Children } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { Button, Hidden, Grid, Typography, MobileStepper, SvgIcon } from '@quillbot/design-system';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  sliderBtn: {
    height: '60px',
    top: '50%',
    position: 'absolute',
    marginTop: '-30px',
    zIndex: 99,
  },
  bottomContainer: {
    marginTop: '15px',
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
  },
}));

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export default function SliderWithMobileSteps(props: {
  children: ReactNodeArray;
  autoplay?: boolean;
  interval?: number;
  showControlOnEnd?: boolean;
  showBottomControl?: boolean;
  mobileStepperContainerStyle?: object;
  mobileStepperStyle?: object;
  slidercontainerStyle?: object;
  mobileStepperClasses?: any;
  controlBtnStyle?: object;
}) {
  const [activeTestimonial, setactiveTestimonial] = useState(0);

  const handleTestimonialBack = () => {
    setactiveTestimonial((state) => state - 1);
  };

  const handleTestimonialNext = () => {
    setactiveTestimonial((state) => state + 1);
  };
  const handleTestimonialChange = (step: number) => {
    setactiveTestimonial(() => step);
  };
  const classes = useStyles();
  const slides = Children.toArray(props.children).length;
  const SwipeableViewsComponent =
    props.autoplay === false ? SwipeableViews : AutoPlaySwipeableViews;

  return (
    <>
      <Hidden only={['xs']}>
        <Button
          className={classes.sliderBtn}
          style={{
            left: '0px',
            visibility: props.showControlOnEnd || activeTestimonial !== 0 ? 'visible' : 'hidden',
            ...props.controlBtnStyle,
          }}
          variant="text"
          size="large"
          onClick={handleTestimonialBack}
          disabled={activeTestimonial === 0}
        >
          <img src="/images/arrow.svg" alt="" style={{ transform: 'rotate(180deg)' }} />
        </Button>
      </Hidden>
      <SwipeableViewsComponent
        interval={props.interval ? props.interval : 5000}
        axis="x"
        containerStyle={props.slidercontainerStyle}
        index={activeTestimonial}
        onChangeIndex={handleTestimonialChange}
        enableMouseEvents
      >
        {props.children}
      </SwipeableViewsComponent>
      <Hidden only={['xs']}>
        <Button
          className={classes.sliderBtn}
          style={{
            right: '0px',
            visibility:
              props.showControlOnEnd || activeTestimonial !== slides - 1 ? 'visible' : 'hidden',
            ...props.controlBtnStyle,
          }}
          size="large"
          onClick={handleTestimonialNext}
          disabled={activeTestimonial === slides - 1}
        >
          <img src="/images/arrow.svg" alt="arrow" />
        </Button>
      </Hidden>
      {!props.showBottomControl ? (
        <Grid
          container
          justifyContent="center"
          style={{
            position: 'absolute',
            bottom: '30px',
            left: '0',
            ...props.mobileStepperContainerStyle,
          }}
        >
          <MobileStepper
            classes={props.mobileStepperClasses}
            variant="dots"
            steps={slides}
            position="static"
            activeStep={activeTestimonial}
            backButton={null}
            nextButton={null}
            style={{ backgroundColor: 'white', ...props.mobileStepperStyle }}
          />
        </Grid>
      ) : (
        <Grid container justifyContent="center" className={classes.bottomContainer}>
          <Grid item container justifyContent="center" alignItems="center">
            <SvgIcon width="5" height="10" viewBox="0 0 5 10" fill="none">
              <path d="M5 -2.18557e-07L2.18557e-07 5L5 10L5 -2.18557e-07Z" fill="#252525" />
            </SvgIcon>
            <Typography style={{ margin: '0px 10px' }}>{`${
              activeTestimonial + 1
            }/${slides}`}</Typography>
            <SvgIcon width="5" height="10" viewBox="0 0 5 10" fill="none">
              <path d="M0 -2.18557e-07L5 5L-4.37114e-07 10L0 -2.18557e-07Z" fill="#252525" />
            </SvgIcon>
          </Grid>
        </Grid>
      )}
    </>
  );
}
